import { render, staticRenderFns } from "./accordionPaySetTables.vue?vue&type=template&id=117080ba&scoped=true"
import script from "./accordionPaySetTables.vue?vue&type=script&lang=js"
export * from "./accordionPaySetTables.vue?vue&type=script&lang=js"
import style0 from "./accordionPaySetTables.vue?vue&type=style&index=0&id=117080ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117080ba",
  null
  
)

export default component.exports